var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.998047H2C1.46957 0.998047 0.960859 1.20876 0.585786 1.58383C0.210714 1.95891 0 2.46761 0 2.99805V18.998C0 19.5285 0.210714 20.0372 0.585786 20.4123C0.960859 20.7873 1.46957 20.998 2 20.998H14C14.5304 20.998 15.0391 20.7873 15.4142 20.4123C15.7893 20.0372 16 19.5285 16 18.998V6.99805L10 0.998047ZM14 18.998H2V2.99805H9V7.99805H14V18.998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a2826841d8e3add91b28522f285d35d6.svg";
export { ForwardRef as ReactComponent };